import React, { ReactElement } from 'react';
import Carousel from 'react-multi-carousel';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-multi-carousel/lib/styles.css';
import Partners from '../../../data/Partners';

import './PartnerCarousel.scss';
import '../home.scss';

const PartnerCarousel = (): ReactElement => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 5,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
    },
  };

  return (
    <div className="partnerCarouselContainer">
      <Carousel
        responsive={responsive}
        arrows={false}
        infinite
        autoPlay
        autoPlaySpeed={2000}
      >
        {Partners.map((partner) => (
          <a
            key={partner.alt}
            target="_blank"
            href={partner.website}
            rel="noopener noreferrer"
            aria-label={partner.alt}
            className="carousel-item"
          >
            <img
              width="100%"
              src={partner.imageUrl}
              className="attachment-medium size-medium lazyloaded carousel-image"
              alt={partner.alt}
              data-lazy-srcset={`${partner.imageUrl} 150w, ${partner.imageUrl} 300w, ${partner.imageUrl} 1024w, ${partner.imageUrl} 84w`}
              data-lazy-sizes="(max-width: 300px) 100vw, 300px"
              data-lazy-src={partner.imageUrl}
              sizes="(max-width: 300px) 100vw, 300px"
              srcSet={`${partner.imageUrl} 84w`}
            />
          </a>
        ))}
      </Carousel>
    </div>
  );
};

export default PartnerCarousel;
